'use strict';
const angular = require('angular');
const {isString} = angular;

var galleryTemplate = require('./gallery-item.html');
var listTemplate = require('./list-item.html');

module.exports.directive = [
  'TransformerDirectiveFactory',
  PendingUploadDirective];

module.exports.templates = [
  '$templateCache',
  CacheTemplates];

function CacheTemplates($templateCache) {
  $templateCache.put('core-components/upload-service/gallery-item.html', galleryTemplate);
  $templateCache.put('core-components/upload-service/list-item.html', listTemplate);
}

function PendingUploadDirective(TransformerDirectiveFactory) {
  var transformConfig = {
    modes: [
      {name: 'gallery', templateUrl: 'core-components/upload-service/gallery-item.html'},
      {name: 'list', templateUrl: 'core-components/upload-service/list-item.html', defaultMode: true}
    ]
  };

  // image-width is only optional if only list-item view is being used
  return {
    restrict: 'E',
    template: '',
    scope: {
      model: '=',
      currentMode: '=?',
      imageWidth: '=?'
    },
    controllerAs: 'uploadItem',
    bindToController: true,
    controller: ['$scope', '$window', '$timeout', 'FileDomain', 'PersistentUploaderService', 'UPLOAD_STATUS', PendingUploadController],
    compile: TransformerDirectiveFactory(transformConfig)
  }
}

function PendingUploadController($scope, $window, $timeout, FileDomain, PersistentUploaderService, UPLOAD_STATUS) {
  var MAX_PREVIEW_SIZE = 1.5 * 1024 * 1024;
  var vm = this;
  var fileData;
  var progressSub = null;
  var currentTimeout = null;

  vm.isPending = isPending;
  vm.isUploading = isUploading;
  //console.log('creating upload preview');

  var unwatch = $scope.$watch(function () {
    return !!vm.model;
  }, function (modelAvailable) {
    if (modelAvailable) {
      unwatch();

      //console.log('showing preview for ', vm.model);

      fileData = PersistentUploaderService.getFileData(vm.model.key);

      getFilePreview();
      waitForUpload(vm.model.key);
    } else {
      fileData = null;
    }
  });

  $scope.$on('$destroy', cleanup);

  var watchingKey = null;

  function waitForUpload(key) {
    if (watchingKey !== null && watchingKey !== key && currentTimeout !== null) {
      $timeout.cancel(currentTimeout);
      currentTimeout = null;
      return;
    }

    vm.progress = true;
    watchingKey = key;
    var promise = PersistentUploaderService.getUploadPromise(key);
    if (!promise) {
      currentTimeout = $timeout(waitForUpload.bind({}, key), 150);
    } else {
      bindPromise(promise);
      bindProgress(PersistentUploaderService.getUploadProgressObservable(key));
    }
  }

  function isPending() {
    return !fileData || vm.progress === true;
  }

  function isUploading() {
    return fileData && fileData.uploadStatus === UPLOAD_STATUS.UPLOADING && vm.progress !== true;
  }

  function getFilePreview() {
    var key = vm.model.key;
    var file = PersistentUploaderService.getFile(vm.model.key);
    if (FileDomain.fileIsImage(file)) {
      vm.isImage = true;
      if (vm.model.fileUri) {
        vm.imageData = vm.model.fileUri;
        PersistentUploaderService.addFileUrlData(key, {url: vm.model.fileUri});

      } else if (file.size < MAX_PREVIEW_SIZE && $window.FileReader) {
        var fileReader = new $window.FileReader();

        fileReader.onload = function onload(event) {
          $scope.$apply(function apply() {
            vm.imageData = event.target.result;
            PersistentUploaderService.addFileUrlData(key, {url: event.target.result});
          });
        };

        fileReader.readAsDataURL(file);
      }
    } else {
      vm.isImage = false;
      vm.fileIcon = getFileIcon();
    }
  }

  function getFileIcon() {
    var list = vm.model && isString(vm.model.type) && vm.model.type.split('/');
    return list[list.length - 1].toUpperCase();
  }

  function bindPromise(promise) {
    if (promise)
      promise.then(onUploadSuccess, onUploadError);
  }

  function bindProgress(promise) {
    if (promise) {
      promise.then(function (progress$) {
        progressSub = progress$.subscribe(onUploadProgress);
      });
    }
  }

  function onUploadSuccess() {
    vm.complete = true;
  }

  function onUploadError() {
    vm.hasError = true;
  }

  function onUploadProgress(progress) {
    if (progress.lengthComputable) {
      vm.progress = (progress.loaded / progress.total) * 100;
    } else {
      vm.progress = true;
    }
  }

  function cleanup() {
    if (progressSub)
      progressSub.unsubscribe();
    if (currentTimeout) {
      $timeout.cancel(currentTimeout);
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/upload-service/pending-upload/PendingUploadDirective.js